import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get, find, filter } from 'lodash'

import RevenueCenterTitle from '../components/RevenueCenterTitle'
import { makeGetCurrentMenu, getSelectedMenus } from '../selectors/menus'
import { makeGetTabOrder } from '../selectors/order'
import { hasCartItems } from '../selectors/cart'
import { currentMenuSelected } from '../actions/menus'
import { clearCart } from '../actions/cart'

const mapStateToProps = (state, ownProps) => {
  const orderId = get(ownProps, 'match.params.orderId')
  const getMenu = makeGetCurrentMenu()
  const menu = getMenu(state)
  const cartItemsExist = hasCartItems(state)
  const isRestockMenu = get(menu, 'subtype') === 'restock'

  // This is a restock order if the order has that type or if there is no type (i.e. a new order)
  // and there are items and those items came from the restock menu.
  const getTabOrder = makeGetTabOrder()
  const orderType = getTabOrder(state, orderId)?.orderType

  // Restrict only to restock menus if this order has a well-defined restock type.
  const shoudlRestrictToRestockMenus = orderType === 'restock'
  // Display the restock menu if this order does not have a well-defined type or restock menus are
  // all that should be shown.
  const shouldDisplayRestockMenu = orderType === undefined || shoudlRestrictToRestockMenus

  let menus = getSelectedMenus(state)
  let forceMenuChange = false
  let nextMenuUuid = undefined

  // TODO(mkramerl): Get this display data into callbacks; update the in-memory cart's type
  // appropriately.
  if (!shouldDisplayRestockMenu) {
    menus = filter(menus, (menu) => menu.subtype !== 'restock')
  } else if (shoudlRestrictToRestockMenus) {
    menus = filter(menus, (menu) => menu.subtype === 'restock')
  }

  if (shoudlRestrictToRestockMenus && !isRestockMenu) {
    forceMenuChange = true
    nextMenuUuid = find(menus, ['subtype', 'restock']).uuid
  }

  if (!shouldDisplayRestockMenu && isRestockMenu) {
    forceMenuChange = true
    nextMenuUuid = find(menus, (menu) => menu.subtype !== 'restock').uuid
  }

  if (menus.length > 0 && !(menu && menus.includes(menu))) {
    forceMenuChange = true
    nextMenuUuid = menus[0].uuid
  }

  return {
    currentMenu: menus.length > 0 ? menu : null,
    isOffline: false,
    menus,
    cartItemsExist,
    forceMenuChange,
    nextMenuUuid,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentMenuId: (menuId) => dispatch(currentMenuSelected(menuId)),
    clearCart: () => dispatch(clearCart()),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RevenueCenterTitle))
